import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

type useConfirmBeforeRouteChangeProps = {
  confirmMessage?: string;
  needConfirm: boolean;
};

export default function useConfirmBeforeRouteChange({
  confirmMessage = '변경사항을 저장하지 않고 나가시겠습니까?',
  needConfirm = false,
}: useConfirmBeforeRouteChangeProps) {
  const message = useRef<string>(confirmMessage);
  const router = useRouter();

  useEffect(() => {
    const handleBeforeunload = (event: BeforeUnloadEvent) => {
      if (needConfirm) {
        event.preventDefault();
        event.returnValue = message.current;
      }
    };

    window.addEventListener('beforeunload', handleBeforeunload);

    return () => window.removeEventListener('beforeunload', handleBeforeunload);
  });

  useEffect(() => {
    const handleRouteChangeStart = () => {
      if (!needConfirm) {
        return;
      }

      if (confirm(message.current)) {
        return true;
      }

      router.events.emit('routeChangeError');
      maintainCurrentPageUrl(router.asPath);

      throw ''; // FIXME: next/router에서 route change를 cancel을 지원할 시 수정 필요
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => router.events.off('routeChangeStart', handleRouteChangeStart);
  });
}

const maintainCurrentPageUrl = (currentUrl: string) => {
  if (currentUrl !== window.location.pathname) {
    window.history.pushState('', '', currentUrl);
  }
};
